<template><Catalog viewer="student" /></template>

<script>
import Catalog from './Catalog';

export default {
  name: 'StudentCourseList',
  components: { Catalog }
};
</script>
